import { createReducer } from '@reduxjs/toolkit';

import * as appSettingsActionTypes from './appSettings.actions';
import { AppSettingsState } from './models';

const INITIAL_STATE: AppSettingsState = {
  appSettings: null,
  loading: false,
  loaded: false,
  errMsg: ''
};

const appSettingsReducer = createReducer(INITIAL_STATE, (builder) => {
  builder
    .addCase(appSettingsActionTypes.loadAppSettingsStart, (state) => {
      return {
        ...state,
        loading: true,
        loaded: false
      };
    })
    .addCase(appSettingsActionTypes.loadAppSettingsSuccess, (state, action) => {
      return {
        ...state,
        appSettings: action.payload,
        loading: false,
        loaded: true
      };
    })
    .addCase(appSettingsActionTypes.loadAppSettingsFailure, (state, action) => {
      return {
        ...state,
        loading: false,
        loaded: false,
        errMsg: action.payload

      };
    });
});

export default appSettingsReducer;